import { Checkbox, ChoiceGroup, IButtonStyles, PrimaryButton, TextField } from '@fluentui/react';
import { Text, ITextProps } from '@fluentui/react/lib/Text';
import React, { useMemo, useRef, useState } from 'react';
import { motion } from "framer-motion"
import { Controller, useForm } from 'react-hook-form';
import { card } from '../App';


const Results: React.FC<ResultsProps> = (props: ResultsProps) => {

    const btnStyles: IButtonStyles = {
        rootHovered: {
            backgroundColor: "rgba(13,168,182,1)",
            border: 0
        },
        rootPressed: {
            backgroundColor: "#1a1b4a",
            border: 0
        },
        root: {
            fontSize: '18px',
            padding: '20px',
            border: 0,
            borderRadius: '10px',
            // width: '100%'
        }
    };

    // if (props.results.filter(r => r.result === true).length === 0) {
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0 }}
            className='cardsection' style={{ textAlign: 'left', margin: '0 auto', fontSize: '14px' }}>

            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0 }}
                style={{ textAlign: 'left' }}
            >
                <Text>
                    Je hebt van geen enkele taak aangegeven dat je die doet voor een naaste, het lijkt erop dat je geen mantelzorger bent.
                </Text>
            </motion.div>
            <br />
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 1.5 }}
            >
                <Text>
                    Mocht dat voor jou in de toekomst veranderen, of denk je dat je toch hulp nodig hebt? Neem dan contact op met Fello via 085 303 62 96 of info@fello.nl, ook voor de hele kleine vragen.
                </Text>
            </motion.div>
        </motion.div>
    )
    // }
    // else
    // return (
    //     <motion.div
    //         initial={{ opacity: 0 }}
    //         animate={{ opacity: 1 }}
    //         transition={{ delay: 0 }}
    //         className='cardsection' style={{ textAlign: 'center', margin: '0 auto', fontSize: '14px' }}>

    //         <motion.div
    //             initial={{ opacity: 0 }}
    //             animate={{ opacity: 1 }}
    //             transition={{ delay: 0 }}
    //             style={{ textAlign: 'center' }}
    //         >
    //             <Text>
    //                 Je hebt van <b>{props.results.filter(r => r.result === true).length}</b> {props.results.filter(r => r.result === true).length === 1 ? 'taak' : ' taken'} aangegeven dat je die wel eens doet voor een ander:
    //                 <ul style={{listStyle: 'none'}}>
    //                     {props.results.filter(r => r.result === true).map(r => {
    //                         return (
    //                             <li>{r.name}</li>
    //                         );
    //                     })}
    //                 </ul>
    //             </Text>
    //         </motion.div>

    //         <motion.div
    //             initial={{ opacity: 0 }}
    //             animate={{ opacity: 1 }}
    //             transition={{ delay: 1.5 }}
    //         >
    //             <Text>
    //                 Je bent daardoor wel degelijk mantelzorger. Misschien wist je dit al, of misschien is dit nieuw voor je.
    //                 <br /><br />
    //                 We willen je graag nog een paar extra vragen stellen om je meer inzicht te geven in de balans in jouw leven.
    //             </Text>
    //         </motion.div>
    //         <br /><br /><br />
    //         <motion.div
    //             initial={{ opacity: 0 }}
    //             animate={{ opacity: 1 }}
    //             transition={{ delay: 2.5 }}
    //         >
    //             <PrimaryButton iconProps={{ iconName: 'Forward' }} styles={btnStyles} text="Verder" onClick={() => { props.next(); }} />
    //         </motion.div>
    //     </motion.div>
    // )
}

export default Results;

interface ResultsProps {
    results: card[];
    next: () => void;
}